import script from "./ColorCardMark.vue?vue&type=script&setup=true&lang=js"
export * from "./ColorCardMark.vue?vue&type=script&setup=true&lang=js"

import "./ColorCardMark.vue?vue&type=style&index=0&id=c976f950&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c976f950"]])

export default __exports__